import type { FieldObject } from '@/utils/types';
import { useSyncExternalStore } from 'react';

const fieldVersions = new WeakMap<object, Map<string, number>>();

function getFieldVersion(object: object, field: string) {
  return fieldVersions.get(object)?.get(field) ?? 0;
}

function bumpFieldVersion(object: object, field: string) {
  const versions = fieldVersions.get(object) ?? new Map<string, number>();
  versions.set(field, (versions.get(field) ?? 0) + 1);
  fieldVersions.set(object, versions);
}

export function useFieldValue<T>(object: FieldObject<T>, field: string): T {
  useSyncExternalStore(
    notify =>
      object.on(field, () => {
        bumpFieldVersion(object, field);
        notify();
      }),
    () => getFieldVersion(object, field),
    () => getFieldVersion(object, field),
  );

  return object.get(field);
}
